import { useState } from "react";
import { NavLink, Link } from "react-router-dom";
import { Menu, X } from "lucide-react";
import Logo from "./Logo";

const links = [
  { to: "/", label: "Home" },
  { to: "/today", label: "Space Today" },
  { to: "/apod", label: "Picture of the Day" },
  { to: "/mars-rover", label: "Mars Rover" },
  { to: "/earth", label: "Earth From Space" },
  { to: "/asteroids", label: "Asteroids" },
  { to: "/gallery", label: "Space Gallery News" },
  { to: "/planets", label: "Planets" },
  { to: "/about", label: "About" },
];

export default function Navbar() {
  const [open, setOpen] = useState(false);
  return (
    <header className="fixed top-0 left-0 right-0 z-40 navbar" data-testid="navbar">
      <div className="max-w-7xl mx-auto px-6 h-16 flex items-center justify-between">
        <Logo />
        <nav className="hidden lg:flex items-center gap-1">
          {links.map((l) => (
            <NavLink
              key={l.to}
              to={l.to}
              end={l.to === "/"}
              data-testid={`nav-${l.label.toLowerCase().replace(/\s+/g, "-")}`}
              className={({ isActive }) =>
                `px-3 py-2 rounded-full text-[13px] tracking-tight transition-colors ${
                  isActive
                    ? "text-white bg-white/10"
                    : "text-white/65 hover:text-white hover:bg-white/5"
                }`
              }
            >
              {l.label}
            </NavLink>
          ))}
        </nav>
        <div className="flex items-center gap-2">
          <Link
            to="/contact"
            data-testid="nav-contact-btn"
            className="hidden sm:inline-flex btn-pill btn-primary !py-2 !px-4 !text-[13px]"
          >
            Contact
          </Link>
          <button
            aria-label="Toggle menu"
            data-testid="mobile-menu-toggle"
            onClick={() => setOpen((v) => !v)}
            className="lg:hidden inline-flex items-center justify-center w-10 h-10 rounded-full border border-white/10 bg-white/5 hover:bg-white/10 transition-colors"
          >
            {open ? <X size={16} /> : <Menu size={16} />}
          </button>
        </div>
      </div>
      {open && (
        <div className="lg:hidden border-t border-white/5 bg-black/85 backdrop-blur-xl">
          <div className="max-w-7xl mx-auto px-6 py-4 flex flex-col gap-1">
            {links.map((l) => (
              <NavLink
                key={l.to}
                to={l.to}
                end={l.to === "/"}
                onClick={() => setOpen(false)}
                className={({ isActive }) =>
                  `px-3 py-2 rounded-xl text-[14px] ${
                    isActive ? "text-white bg-white/10" : "text-white/75 hover:bg-white/5"
                  }`
                }
              >
                {l.label}
              </NavLink>
            ))}
            <Link
              to="/contact"
              onClick={() => setOpen(false)}
              className="mt-2 btn-pill btn-primary justify-center"
            >
              Contact
            </Link>
          </div>
        </div>
      )}
    </header>
  );
}
